import React, { useState, useEffect, useCallback } from "react";
import { useRouteMatch } from "react-router-dom";
import { Container, Segment, Header, Checkbox } from "semantic-ui-react";
import Tabs from "./components/tabs";
import axios from "../../../config/axios";

import "./styles.css";
import GoBack from "../../../components/go-back";

const BuildingsDetails = () => {
  const match = useRouteMatch();
  const [building, setBuilding] = useState({
    documents: {},
    company: {},
    location: { address: {} },
    labels: {},
    blocks: [],
  });
  const { id } = match.params;
  const fetchBuilding = useCallback(async () => {
    const params = {
      $select: [
        "company",
        "name",
        "location.address",
        "createAt",
        "active",
        "labels",
        "orientation",
        "timezone",
        "configuration",
        "classification",
        "isContract"
      ],
      $populate: [
        {
          path: "company",
          select: ["name"]
        },
      ],
    };
    const { data: building } = await axios.get(`buildings/${id}`, { params });

    setBuilding(building);
  }, [id]);
  const updateBuilding = (data) => axios.patch(`buildings/${id}`, data);
  const changeBuildingPlan = async (plans) => {
    const configuration = { ...building.configuration, plans };

    updateBuilding({ configuration });
    setBuilding({ ...building, configuration });
  };
  const activateOrInactivateBuilding = async (_, { checked }) => {
    updateBuilding({ active: checked });
    setBuilding({ ...building, active: checked });
  };
  const updateClassification = async (classification ) => {
    updateBuilding({ classification: classification })
    setBuilding({ ...building, classification: classification })
  };
  const updateCategory = async (category) => {
    updateBuilding({ category: category });
    setBuilding({ ...building, category: category});
  };
  const updateIsContract = async ( isContract ) =>  {
    updateBuilding({ isContract: isContract })
    setBuilding({ ...building, isContract: isContract })
  };
  const activateOrInactivateBuildingModule =
    (attribute) =>
    async (_, { checked }) => {
      if (attribute === 'configuration.integrations.bigDataCorp.enabled') {
        const updateData = { 
          [attribute]: checked,
          'configuration.integrations.bigDataCorp.alertSettings.enabled': checked
        };

        if (checked) {
          updateData['configuration.integrations.bigDataCorp.alertSettings.alertTypes.arrest_warrant'] = true;
          updateData['configuration.integrations.bigDataCorp.alertSettings.alertTypes.sanctions'] = true;
          updateData['configuration.integrations.bigDataCorp.alertSettings.alertTypes.pep'] = true;
          updateData['configuration.integrations.bigDataCorp.alertSettings.alertTypes.criminal_history'] = true;
        }
        
        await updateBuilding(updateData);
      } else if (attribute === 'configuration.modules.cerus.enabled') {
        const currentConfiguration = building.configuration || {};
        const currentModules = currentConfiguration.modules || {};
        const configuration = {
          ...currentConfiguration,
          modules: {
            ...currentModules,
            cerus: {
              ...(currentModules.cerus || {}),
              enabled: checked
            }
          }
        };

        await updateBuilding({ configuration });
      } else {
        await updateBuilding({ [attribute]: checked });
      }
      fetchBuilding();
    };

  useEffect(() => {
    fetchBuilding();
  }, [fetchBuilding]);

  return (
    <Container className="page">
      <Segment.Group>
        <Segment className="building-details-title-segment">
          <GoBack route="/" />
          <Header as="h2">{building.name}</Header>
          <Checkbox
            toggle
            label={building.active ? "Ativo" : "Desativado"}
            checked={building.active}
            onChange={activateOrInactivateBuilding}
          />
        </Segment>
        <Segment>
          <Tabs
            building={building}
            changeBuildingPlan={changeBuildingPlan}
            activateOrInactivateBuildingModule={
              activateOrInactivateBuildingModule
            }
            updateClassification={updateClassification}
            updateIsContract={updateIsContract}
            updateCategory={updateCategory}
          />
        </Segment>
      </Segment.Group>
    </Container>
  );
};

export default BuildingsDetails;
